import { Button, Card, Grid2, Typography } from "components";
import { Edit1Icon } from "components/Icons";
import { useState } from "react";
import InvoiceCardModal from "./InvoiceCardModal";

interface Props {
  invoiceSeriesData: any;
  invoiceSeriesRefetch: () => void;
}

const InvoiceCard = (props: Props) => {
  const { invoiceSeriesData, invoiceSeriesRefetch } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={2.8}>
        <Card sx={{ p: 1.5, background: "var(--neutral-50)" }}>
          <Grid2 container alignItems="center" justifyContent="space-between">
            <Grid2>
              <Typography fontSize={12} fontWeight={500}>
                Invoice Series:
              </Typography>
              <Typography
                fontSize={15}
                fontWeight={500}
                color="var(--primary-900)"
              >
                {invoiceSeriesData?.data?.data?.invoiceSeries || "-"}
              </Typography>
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
      <Grid2 size={2.8}>
        <Card sx={{ p: 1.5, background: "var(--neutral-50)" }}>
          <Grid2 container alignItems="center" justifyContent="space-between">
            <Grid2>
              <Typography fontSize={12} fontWeight={500}>
                Invoice Length:
              </Typography>
              <Typography
                fontSize={15}
                fontWeight={500}
                color="var(--primary-900)"
              >
                {invoiceSeriesData?.data?.data?.invoiceLength || "-"}
              </Typography>
            </Grid2>
          </Grid2>
        </Card>
      </Grid2>
      <Grid2 container justifyContent="flex-end" alignItems="center">
        <Button
          variant="secondaryDark"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          <Edit1Icon fontSize="small" />
        </Button>
      </Grid2>

      {isModalOpen && (
        <InvoiceCardModal
          open={isModalOpen}
          setOpen={setIsModalOpen}
          invoiceSeriesData={invoiceSeriesData?.data?.data}
          invoiceSeriesRefetch={invoiceSeriesRefetch}
        />
      )}
    </Grid2>
  );
};

export default InvoiceCard;
